import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Typography,
  Grid,
  Container,
  CircularProgress,
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { getProducts } from './../../store/actions';
import Header from './../Header';
import Hero from './Hero';
import Footer from './../Footer';
import Product from './Products';
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  cardGrid: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
  },
  feedback: {
    diplay: 'flex',
    textAlign: 'center',
  },
}));

const Homepage = () => {
  const classes = useStyles();
  const [productData, setproductData] = useState([]);
  const dispatch = useDispatch();
  const { request, products, error } = useSelector((state: any) => {
    return state;
  });

  useEffect(() => {
    setproductData(products);
  }, [products]);

  useEffect(() => {
    dispatch(getProducts());
  }, []);

  return (
    <div className={classes.root}>
      <Header />
       <Hero />
      <Container className={classes.cardGrid} maxWidth="lg">
        {error && (
          <Typography variant="h5" align="center" className={classes.feedback}>
            An error occured please try again
          </Typography>
        )}
        {request ? (
          <div className={classes.feedback}>
            <CircularProgress size="5rem" thickness={2} />
          </div>
        ) : (
          <Grid container spacing={4}>
            {productData.length ? (
              productData.map((product) => {
                return (
                  <Product product={product.attributes} key={product.id} />
                );
              })
            ) : (
              <Typography className={classes.feedback}>
                No Product yet
              </Typography>
            )}
          </Grid>
        )}
      </Container>
      <Footer />
    </div>
  );
};

export default Homepage;
